<template>
    <div class="main-wrapper"> 
        <div>
            <h3> {{ mainHeader }} </h3>
            <p> {{ mainStory }} </p>
        </div>
        <div class="main-update" v-if="mainUpdate && mainUpdate.length > 1">
            <p><b>Päivitys: </b> {{ mainUpdate }} </p>        
        </div>
    </div>
</template>

<script>

export default {
    name: 'MainText',
    props: ['mainHeader', 'mainStory', 'mainUpdate']
}
</script>

<style scoped>
h3 {
    font-size: 1.75rem;
    margin-bottom: .5rem;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.2;
    color: inherit;
}

.main-wrapper {
    margin-bottom: 2%;
    margin-left: 5%;
    margin-right: 5%;

}

</style>>